module.exports = __webpack_public_path__ + "img/cx_betahcg.5fa7322f.webp";